export const isErrorCode = (error: unknown, errorCode: string) => {
  return (
    error &&
    typeof error === 'object' &&
    'error' in error &&
    error.error &&
    typeof error.error === 'object' &&
    'errorCode' in error.error &&
    error.error.errorCode === errorCode
  )
}
